import { Link } from "react-router-dom";
import { SiteFooter } from "@/components/layout/SiteFooter";
import { CONTACT, PRIVACY, TERMS, UPDATED } from "@/lib/legalContent";

const DOCS = { privacy: ["Privacy Policy", PRIVACY], terms: ["Terms of Use", TERMS] };

export default function Legal({ doc }) {
  const [title, sections] = DOCS[doc];
  return (
    <div className="flex min-h-screen flex-col bg-[#050811]">
      <header className="flex items-center justify-between border-b border-[#1E2D4A] bg-[#070A14] px-4 py-3 sm:px-6">
        <Link to="/browse" className="flex items-center gap-3"><img src="/ranger-logo.jpg" alt="RANGER" className="h-9 w-9 rounded-sm" /><span className="font-display text-xl font-bold uppercase tracking-[0.25em] text-slate-100">Ranger</span></Link>
        <Link to="/login" className="text-xs text-slate-300 hover:text-white">Sign in</Link>
      </header>
      <main className="mx-auto w-full max-w-3xl flex-1 px-4 py-12">
        <h1 data-testid="legal-title" className="text-4xl font-bold uppercase tracking-wide text-slate-100 sm:text-5xl">{title}</h1>
        <p className="mt-2 font-mono text-xs text-slate-500">Last updated {UPDATED}</p>
        <div className="mt-10 space-y-8">{sections.map(([h, body]) => (
          <section key={h}>
            <h2 className="text-base font-semibold uppercase tracking-wider text-slate-200 md:text-lg">{h}</h2>
            <p className="mt-2 text-sm leading-relaxed text-slate-400">{body}</p>
          </section>
        ))}</div>
        <a data-testid="legal-contact" href={CONTACT} target="_blank" rel="noreferrer" className="mt-10 inline-block rounded-sm bg-[#5865F2] px-4 py-2 text-xs font-semibold uppercase tracking-wider text-white transition-colors hover:bg-[#4752c4]">Contact us on Discord</a>
      </main>
      <SiteFooter />
    </div>
  );
}
